import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import CollapsibleBrokersTable, {ColumnDef } from "./collapsibleBrokersTable";

type Props = {
    data? : any;
    showBrokers?: boolean;
    showReps?: boolean;
    selected? : any;
    setSelected ?: any;
    onDoubleClick?: (partyId : any) => void;
  };

export default function CollapsibleBrokersWrapper ({
    data = [],
    showBrokers = true,
    showReps = true,
    selected,
    setSelected,
    onDoubleClick
  }: Props) {
    const columns: ColumnDef[] = [
      { header: "ISO / BROKER SHOP", accessor: "name", width: 250 },
      { header: "SALES REP", accessor: "salesRep", width: 250 },
      { header: "EMAIL", accessor: "email", width: 250 },
      { header: "PHONE NUMBER", accessor: "phone", width: 160 },
      { header: "LAST FUNDED", accessor: "lastFunded", width: 120, align: "center" },
      { header: "BIRTHDAY", accessor: "birthday", width: 120, align: "center" },
      { header: "# OF FUNDED", accessor: "funded", width: 120, align: "right" },
      { header: "LAST SUBMISSION", accessor: "lastSubmission", width: 140, align: "center" },
      { header: "# OF SUBMISSIONS", accessor: "submissions", width: 150, align: "right" },
      { header: "# OF DECLINED", accessor: "declined", width: 130, align: "right" },
      { header: "# DEFAULTS", accessor: "defaults", width: 110, align: "right" },
      {
        header: "PENDING RESPONSE",
        accessor: "pendingResponse",
        width: 160,
        align: "center",
        groupCell: ({ value }: { value: number }) => (
          <Typography sx={{ fontWeight: 800, fontSize: "0.85rem" }}>
            {Number(value) > 0 ? "Yes" : "No"}
          </Typography>
        ),
        cell: ({ value }: { value: number }) => (
          <Typography sx={{ fontSize: "0.82rem" }}>
            {Number(value) > 0 ? "Yes" : "No"}
          </Typography>
        ),
      },
      {
        header: "COMMISSIONS PAID",
        accessor: "commissionsPaid",
        width: 160,
        align: "right",
        groupCell: ({ value }) => (
          <Typography sx={{ fontWeight: 800, fontSize: "0.85rem" }}>
            {typeof value === "number" ? `$${value.toLocaleString()}` : value ?? ""}
          </Typography>
        ),
        cell: ({ value }) => (
          <Typography sx={{ fontSize: "0.82rem" }}>
            {typeof value === "number" ? `$${value.toLocaleString()}` : value ?? ""}
          </Typography>
        ),
      },
      {
        header: "COMMISSIONS OWED",
        accessor: "commissionsOwed",
        width: 160,
        align: "right",
        groupCell: ({ value }) => (
          <Typography sx={{ fontWeight: 800, fontSize: "0.85rem" }}>
            {typeof value === "number" ? `$${value.toLocaleString()}` : value ?? ""}
          </Typography>
        ),
        cell: ({ value }) => (
          <Typography sx={{ fontSize: "0.82rem" }}>
            {typeof value === "number" ? `$${value.toLocaleString()}` : value ?? ""}
          </Typography>
        ),
      },
    ];

  
    return (
      <Box sx={{ p: 2 }}>
        <CollapsibleBrokersTable
          rowKey = "uniqueId"
          rows={data}
          columns={columns}
          selectedKey={selected}
          onChangeSelected={setSelected}
          onDoubleClick= {onDoubleClick}
          showBrokers={showBrokers}
          showReps={showReps}
          stickyHeader={true}
          stripe
        />
      </Box>
    );
  };